var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.07 7.4556C7.02917 7.44977 6.97667 7.44977 6.93 7.4556C5.90334 7.4206 5.08667 6.5806 5.08667 5.5481C5.08667 4.49227 5.93834 3.63477 7 3.63477C8.05584 3.63477 8.91334 4.49227 8.91334 5.5481C8.9075 6.5806 8.09667 7.4206 7.07 7.4556Z",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9317 11.3052C9.89333 12.256 8.51666 12.8335 7 12.8335C5.48333 12.8335 4.10666 12.256 3.06833 11.3052C3.12666 10.7568 3.47666 10.2202 4.10083 9.80016C5.69916 8.73849 8.31249 8.73849 9.89916 9.80016C10.5233 10.2202 10.8733 10.7568 10.9317 11.3052Z",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 12.8327C10.2217 12.8327 12.8333 10.221 12.8333 6.99935C12.8333 3.77769 10.2217 1.16602 7 1.16602C3.77834 1.16602 1.16667 3.77769 1.16667 6.99935C1.16667 10.221 3.77834 12.8327 7 12.8327Z",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.60faed22ac12830da5a28405f00439f8.svg";
export { ForwardRef as ReactComponent };